import {effect, inject, Injectable, signal} from '@angular/core';
import {ProductSampleNewService} from "../../../../shared/common/NEW/services/product-sample-new.service";
import {SampleValidationDTO} from "../../../../shared/common/NEW/interfaces/product-sample.entity";

@Injectable({
    providedIn: 'root'
})
export class ProductDevelopmentHandleService {

    private productSampleService = inject(ProductSampleNewService);

    public selectedSampleId = signal<number | null>(null);
    public designCount = signal<number | null>(null);
    public editingSampleCode = signal<string>('');

    public _sampleValidation = signal<SampleValidationDTO | null>(null);
    public _isAddingDesignMaterial = signal(false);
    public _isAddingNewDesign = signal(false);
    public _isEditingModeEnabled = signal(false);
    public _selectedDesignID = signal<number | null>(null);

    constructor() {
        effect(() => {
            const sampleId = this.selectedSampleId();
            if (sampleId !== null) {
                this.checkSampleValidations(sampleId);
            }
        });
    }

    public checkSampleValidations(sampleID: number): void {
        this.productSampleService.sampleValidator(sampleID).subscribe({
            next: (res) => {
                this._sampleValidation.set(res.data);
            },
            error: (err) => {
                console.error('Error validating sample:', err);
            }
        });
    }

    public resetSignals(): void {
        this.selectedSampleId.set(null);
        this.designCount.set(null);
        this.editingSampleCode.set('');
        this._isAddingDesignMaterial.set(false);
        this._isAddingNewDesign.set(false);
        this._selectedDesignID.set(null);
        this._sampleValidation.set(null);
    }
}
